import React from "react";
import { Sparkles, Zap } from "lucide-react";

export default function IntroOffer() {
  return (
    <section className="relative -mt-4 mb-4" data-testid="intro-offer-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-brand-surfaceAlt via-white to-brand-soft/60 border border-brand-border shadow-sm">
          <div
            aria-hidden
            className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-brand-soft/70 blur-2xl"
          />
          <div
            aria-hidden
            className="absolute -left-10 -bottom-10 w-40 h-40 rounded-full bg-brand-surfaceAlt blur-2xl"
          />
          <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-5 p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="shrink-0 w-12 h-12 rounded-2xl bg-white border border-brand-border grid place-items-center text-brand-primary shadow-sm">
                <Zap size={20} />
              </div>
              <div>
                <div className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-brand-primary text-white text-[10px] font-bold tracking-[0.18em] uppercase">
                  <Sparkles size={11} /> Limited Time
                </div>
                <h3 className="mt-2 font-heading text-xl sm:text-2xl font-medium text-brand-ink">
                  Intro Offer — Get your first hire at a special discount.
                </h3>
                <p className="mt-1 text-sm text-brand-muted">
                  New to Career Connect? Lock in a special rate on your first role placement.
                </p>
              </div>
            </div>
            <a
              href="#contact"
              data-testid="intro-offer-cta"
              className="inline-flex items-center gap-2 rounded-full bg-brand-primary text-white px-5 h-11 text-sm font-semibold hover:bg-brand-primaryHover transition-all hover:-translate-y-0.5 shadow-sm"
            >
              Claim This Offer
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
